<template>
    <div class="row" v-if="trade.trade_contract">
        <div class="col-12 m-t-30">
            <div class="card">
                <div class="card-header">
                    <h4 class="m-b-0"><i class="fas fa-file-signature"></i> Contracts</h4>
                    <p class="text-muted m-t-0">Agreement between buyer and seller is recorded in a smart contract. Below are contract addresses and transaction hashes.</p>
                </div>
                <div class="card-body">
                    <div class="d-flex align-items-center">
                        <div class="m-r-10">
                            <span class="text-orange display-5"><blockie :address="trade.trade_contract" :width="40"></blockie></span>
                        </div>
                        <div class="m-r-40">
                            <div><a :href="$BORLAUG + '/address/' + trade.trade_contract">{{trade.trade_contract}}</a></div>
                            <span class="text-muted">Trade Contract</span>
                        </div>
                    </div>
                    <div class="d-flex align-items-center" v-if="trade.escrow_contract">
                        <div class="m-r-10">
                            <span class="text-orange display-5"><blockie :address="trade.escrow_contract" :width="40"></blockie></span>
                        </div>
                        <div class="m-r-40">
                            <div><a :href="$BORLAUG + '/address/' + trade.escrow_contract">{{trade.escrow_contract}}</a></div>
                            <span class="text-muted">Escrow Contract</span>
                        </div>
                        <div class="m-r-40">
                            <h3 v-if="escrowBalance">{{trade.total_amount | money}}</h3>
                            <span class="text-muted">Escrow Amount</span>
                        </div>
                    </div>
                    <div class="d-flex align-items-center" v-if="trade.payment_contract">
                        <div class="m-r-10">
                            <span class="text-orange display-5"><blockie :address="trade.payment_contract" :width="40"></blockie></span>
                        </div>
                        <div class="m-r-40">
                            <div><a :href="$BORLAUG + '/address/' + trade.payment_contract">{{trade.payment_contract}}</a></div>
                            <span class="text-muted">Payment Contract</span>
                        </div>
                        <div class="m-r-40">
                            <h3 v-if="paymentBalance">{{paymentBalance | money}}</h3>
                            <span class="text-muted">Payment Contract Amount</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Blockie from "../../../common/Blockie";
    import {mapGetters} from "vuex";

    export default {
        name: "TradeDocuments",
        components: {Blockie},
        props: {
            tradeid: String,
            trade: Object,
            events: Object
        },
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        watch: {
            trade: function(newVal, oldVal) {
                if(this.trade.escrow_contract) {
                    this.getEscrowBalance();
                }
                if(this.trade.payment_contract) {
                    this.getPaymentBalance();
                }
            }
        },
        data() {
            return {
                $BORLAUG: this.$BORLAUG,
                escrowBalance: null,
                paymentBalance: null,
                tradeBalance: null
            }
        },
        mounted() {

        },
        methods: {
            async getEscrowBalance() {
                if(this.trade.escrow_contract) {
                    let result         = await this.$http.get(`/trades/${this.trade.trade_id}/${this.trade.escrow_contract}/balance`, {
                        params: {
                            orgid: this.currentOrg.id
                        }
                    });
                    this.escrowBalance = result.data;
                }
            },
            async getPaymentBalance() {
                if(this.trade.payment_contract) {
                    let result          = await this.$http.get(`/trades/${this.trade.trade_id}/${this.trade.payment_contract}/balance`, {
                        params: {
                            orgid: this.currentOrg.id
                        }
                    });
                    this.paymentBalance = result.data;
                }
            }
        }
    }
</script>

<style scoped>
    #trade_contract, #escrow_contract {
        margin-left: auto;
        margin-right: auto;
        margin-top: 30px;
    }
</style>
